
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type garageRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function garageRT(): TemplateResult<garageRTRootProps> {
    return _createElement('div', { 'className': 'cm_garage' }, _createElement('a', {
        'className': 'cm_toggle-dropdown garage-button',
        'title': 'Garage: ' + this.size + ' item(s)',
        'tabIndex': '0',
        'role': 'button'
    }, _createElement('span', { 'className': 'garage-label cm_mobile-hide' }, _translate(`garage_title`)), _createElement('div', { 'className': 'garage-icon-container btn btn--primary' }, [_createElement('svg', {
            'className': 'cm_icon cm_icon-garage',
            'xmlns': 'http://www.w3.org/2000/svg',
            'viewBox': '0 0 24 24',
            'fill': 'none',
            'stroke': 'currentColor',
            'stroke-width': '2.2',
            'stroke-linecap': 'round',
            'stroke-linejoin': 'round',
            'key': '2690'
        }, _createElement('path', { 'd': 'M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.7-1.7-1.5-1.9C18.7 10.6 16 10 16 10s-1.3-1.4-2.2-2.3c-.5-.4-1.1-.7-1.8-.7H5c-.6 0-1.1.4-1.4.9l-1.4 2.9A3.7 3.7 0 0 0 2 12v4c0 .6.4 1 1 1h2' }), _createElement('circle', {
            'cx': '7',
            'cy': '17',
            'r': '2'
        }), _createElement('path', { 'd': 'M9 17h6' }), _createElement('circle', {
            'cx': '17',
            'cy': '17',
            'r': '2'
        }))], _createElement('span', { 'className': 'garage-size red-circle-item-counter' }, this.size))), [this.garageDropdown(function () {
            function repeatItems1(items, itemsIndex) {
                return [items(function () {
                        return _createElement('div', { 'className': 'garage-item' }, _createElement('span', {
                            'className': 'select-model',
                            'onClick': this.selectVehicle
                        }, this.vehicleString), _createElement('span', {
                            'className': 'remove-model',
                            'onClick': this.removeVehicle
                        }, [_createElement('svg', {
                                'width': '13',
                                'height': '13',
                                'viewBox': '0 0 13 13',
                                'fill': 'none',
                                'xmlns': 'http://www.w3.org/2000/svg',
                                'key': '1930'
                            }, _createElement('path', {
                                'fillRule': 'evenodd',
                                'clipRule': 'evenodd',
                                'd': 'M11.9226 0.744078C12.248 1.06951 12.248 1.59715 11.9226 1.92259L1.92259 11.9226C1.59715 12.248 1.06951 12.248 0.744078 11.9226C0.418641 11.5972 0.418641 11.0695 0.744078 10.7441L10.7441 0.744078C11.0695 0.418641 11.5972 0.418641 11.9226 0.744078Z',
                                'fill': '#FF0000'
                            }), _createElement('path', {
                                'fillRule': 'evenodd',
                                'clipRule': 'evenodd',
                                'd': 'M0.744078 0.744078C1.06951 0.418641 1.59715 0.418641 1.92259 0.744078L11.9226 10.7441C12.248 11.0695 12.248 11.5972 11.9226 11.9226C11.5972 12.248 11.0695 12.248 10.7441 11.9226L0.744078 1.92259C0.418641 1.59715 0.418641 1.06951 0.744078 0.744078Z',
                                'fill': '#FF0000'
                            }), _createElement('path', {
                                'fillRule': 'evenodd',
                                'clipRule': 'evenodd',
                                'd': 'M11.9226 0.744078C12.248 1.06951 12.248 1.59715 11.9226 1.92259L1.92259 11.9226C1.59715 12.248 1.06951 12.248 0.744078 11.9226C0.418641 11.5972 0.418641 11.0695 0.744078 10.7441L10.7441 0.744078C11.0695 0.418641 11.5972 0.418641 11.9226 0.744078Z',
                                'stroke': '#FF0000',
                                'strokeLinecap': 'round',
                                'strokeLinejoin': 'round'
                            }), _createElement('path', {
                                'fillRule': 'evenodd',
                                'clipRule': 'evenodd',
                                'd': 'M0.744078 0.744078C1.06951 0.418641 1.59715 0.418641 1.92259 0.744078L11.9226 10.7441C12.248 11.0695 12.248 11.5972 11.9226 11.9226C11.5972 12.248 11.0695 12.248 10.7441 11.9226L0.744078 1.92259C0.418641 1.59715 0.418641 1.06951 0.744078 0.744078Z',
                                'stroke': '#FF0000',
                                'strokeLinecap': 'round',
                                'strokeLinejoin': 'round'
                            }))]));
                    }, { count: undefined })];
            }
            return _createElement('div', { 'className': 'cm_garageDropdown' }, this.template === 'list' ? _createElement('div', {
                'className': 'cmTemplate_list',
                'key': '31'
            }, _createElement('div', { 'className': 'garage-content' }, _createElement('div', {
                'className': 'clear-garage',
                'onClick': this.clearGarage
            }, _translate(`garage_clear`)), _createElement.apply(this, [
                'div',
                { 'className': 'cmRepeater_items' },
                _map(this.items, repeatItems1.bind(this))
            ]), [this.addButton(function () {
                    return _createElement('div', { 'className': 'add-vehicle  btn btn--primary cm_addButton' }, [window.Convermax.config?.garageButtonText || _translate(`garage_add_button`)]);
                }, {
                    widgetName: 'undefined',
                    items: undefined
                })])) : null, this.template === 'empty' ? _createElement('div', {
                'className': 'cmTemplate_empty',
                'key': '3279'
            }, _createElement('div', { 'className': 'garage-content' }, [this.addButton(function () {
                    return _createElement('div', { 'className': 'add-vehicle  btn btn--primary cm_addButton' }, [window.Convermax.config?.garageButtonText || _translate(`garage_add_button`)]);
                }, {
                    widgetName: 'undefined',
                    items: undefined
                })], _createElement('ul', {}, _createElement('li', { 'className': 'vehicle-advantages' }, _translate(`garage_info_line_one`)), _createElement('li', { 'className': 'vehicle-advantages' }, _translate(`garage_info_line_two`)), _createElement('li', { 'className': 'vehicle-advantages' }, _translate(`garage_info_line_three`))))) : null);
        }, {
            widgetName: 'undefined',
            items: undefined
        })]);
}
        export const componentNames = ["cm:addButton","cm:addButton","cm:garageDropdown"]